<template>
  <div class="flex flex-1 flex-col">
    <div
      class="px-4 h-12 w-full flex bg-white border-b border-orange-lighter items-center text-black"
    >
      <EmployeesSM />
    </div>
    <perfect-scrollbar class="content-area">
      <router-view class="p-5 h-full bg-white border-l border-r"></router-view>
    </perfect-scrollbar>
  </div>
</template>

<script>
import EmployeesSM from "./EmployeesSM";
export default {
  name: "Employees",
  components: { EmployeesSM },
};
</script>
